import { Box, Column, Row } from '../Flex';
import { HeadingTwo } from '../Text';
import styled from 'styled-components';
import Link from 'next/link';
import { ADMIN_ROLES } from '../../hooks/useAdmin';

const ChangeFlex = styled(Row)`
  align-items: center;
`;

const A = styled.a`
  cursor: pointer;
  text-align: center;
  font-weight: medium;
  font-size: 15px;
  margin: 0;
  padding-bottom: 5px;
  position: relative;
  color: #717884;
  opacity: 0.5;
  border-bottom: 2px solid transparent;
  transition: opacity 300ms;
  &:hover {
    opacity: 1;
  }
  &.active {
    opacity: 1;
    color: #14b1da;
    border-bottom: 2px solid #14b1da;
  }
`;

export const MerchantNav = ({ role, route }) => {
  return (
    <>
      <Row style={{ alignItems: 'center' }}>
        <HeadingTwo>Merchant</HeadingTwo>
      </Row>
      <Box height={30} />
      <ChangeFlex>
        {/* <Link href="/shop/merchant/orders">
          <A className={route === 'orders' ? 'active' : ''}>Orders</A>
        </Link>
        <Box width={20} height={20} /> */}
        <Link
          href="/shop/merchant/items"
          className={route === 'items' ? 'active' : ''}
        >
          Items{' '}
        </Link>
        <Box width={20} height={20} />
        <Link
          href="/shop/merchant/orders"
          className={route === 'orders' ? 'active' : ''}
        >
          Orders{' '}
        </Link>
        <Box width={20} height={20} />
        <Link
          href="/shop/merchant/settings"
          className={route === 'settings' ? 'active' : ''}
        >
          Settings{' '}
        </Link>
      </ChangeFlex>
    </>
  );
};

export default MerchantNav;
